import { useState, useEffect } from "react";
import { FaSave, FaSpinner, FaCheckCircle, FaExclamationTriangle, FaCog, FaCube, FaUndo, FaRoad, FaTachometerAlt, FaCalendarAlt, FaUsers, FaPercent } from "react-icons/fa";
import ParametrosComissaoService from "../../services/resource/ParametrosComissaoService";
import FuncionarioService from "../../services/resource/funcionarioService";

const defaultValues = {
    calculaCubagem: false,
    calculaRetornoVendas: false,
    calculaConclusaoRota: false,
    calculaTelemetria: false,
    descontaAfastamentos: false,
    exibeSomenteFuncionariosAtivos: false,
    descontaFaltas: false,
    valorPorCuboCom1Auxiliar: 0,
    valorPorCuboCom2Auxiliar: 0,
    valorMaximoPorCuboCom1Auxiliar: 0,
    valorMaximoPorCuboCom2Auxiliar: 0,
    minutosParaRotas24horas: 0,
    minutosParaRotas48horas: 0,
    minutosParaRotas72horas: 0,
    percentualConclusao: 0,
    percentualGreenmile: 0,
    valorConclusaoCom1Auxiliar: 0,
    valorConclusaoCom2Auxiliar: 0,
    metaTelemetria: 0,
    valorTelemetriaCom1Auxiliar: 0,
    valorTelemetriaCom2Auxiliar: 0,
    valorTelemetriaSemProporcao: 0,
    limiteMaximoPercentualRetorno: 0,
    retornoFaixa1Limite: 0,
    retornoFaixa2Limite: 0,
    retornoFaixa3Limite: 0,
    retornoFaixa4Limite: 0,
    retornoFaixa1Valor1Aux: 0,
    retornoFaixa1Valor2Aux: 0,
    retornoFaixa2Valor1Aux: 0,
    retornoFaixa2Valor2Aux: 0,
    retornoFaixa3Valor1Aux: 0,
    retornoFaixa3Valor2Aux: 0,
    retornoFaixa4Valor1Aux: 0,
    retornoFaixa4Valor2Aux: 0,
    retornoFaixa5Valor1Aux: 0,
    retornoFaixa5Valor2Aux: 0,
    maxAuxiliarPorCarga: 0,
    cargosDeMotoristas: [],
    cargosDeAuxiliares: [],
    aplicarProporcionalidadeRota: false,
    aplicarProporcionalidadeTelemetria: false,
    versao: "",
    aplicarProporcionalidadePorDiasTrabalhados: false,
    diaFechamento: 1,
};

export default function ParametrosComissao() {
    const service = new ParametrosComissaoService();
    const funcionarioService = new FuncionarioService();

    const [form, setForm] = useState(defaultValues);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [tipo, setTipo] = useState("MOTORISTA");
    const [cargos, setCargos] = useState([]);

    const [toast, setToast] = useState(null);

    useEffect(() => {
        carregar();
    }, [tipo]);

    useEffect(() => {
        carregarCargos();
    }, []);

    useEffect(() => {
        if (toast) {
            const t = setTimeout(() => setToast(null), 4000);
            return () => clearTimeout(t);
        }
    }, [toast]);

    async function carregar() {
        setLoading(true);

        try {

            const { data } = await service.buscar(tipo);

            setForm({
                ...defaultValues,
                ...data,
                valorEntregaVolume: data.valorEntregaVolume ?? "",
                valorRetornoVendas: data.valorRetornoVendas ?? "",
                valorGreenmile: data.valorGreenmile ?? "",
                valorSegurancaViaria: data.valorSegurancaViaria ?? "",
                cargosDeMotoristas: data.cargosDeMotoristas ?? [],
                cargosDeAuxiliares: data.cargosDeAuxiliares ?? [],
                regrasCubagem: data.regrasCubagem ?? []
            });

        } catch (err) {
            setToast({ type: "error", message: "Erro ao carregar parâmetros" });
        } finally {
            setLoading(false);
        }
    }

    async function carregarCargos() {
        try {
            const { data } = await funcionarioService.listarCargos();
            setCargos(data);
        } catch (err) {
            console.error("Erro ao carregar cargos", err);
        }
    }

    const set = (key) => (value) =>
        setForm(prev => ({ ...prev, [key]: value }));

    async function carregarCargos() {
        try {
            const { data } = await funcionarioService.listarCargos();
            setCargos(data);
        } catch (e) {
            console.error("Erro ao carregar cargos", e);
        }
    }

    const handleSave = async () => {

        setSaving(true);

        try {

            await service.salvar(tipo, form);

            setToast({
                type: "success",
                message: "Parâmetros salvos com sucesso!"
            });

        } catch (err) {

            setToast({
                type: "error",
                message: "Erro ao salvar parâmetros"
            });

        } finally {
            setSaving(false);
        }
    };

    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-background">
                <FaSpinner className="animate-spin text-primary text-4xl" />
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-background">

            <header className="sticky top-0 z-10 bg-card border-b border-border shadow-card">
                <div className=" mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <FaCog className="text-primary text-xl" />
                        <h1 className="text-xl font-bold text-foreground">Parâmetros de Comissão</h1>
                        {form.versao && (
                            <span className="text-xs bg-primary/10 text-primary px-2 py-0.5 rounded-full font-medium">
                                v{form.versao}
                            </span>
                        )}

                        <div className="flex gap-2 ml-4">

                            <button
                                onClick={() => setTipo("MOTORISTA")}
                                className={`px-3 py-1 rounded-md text-sm transition-colors duration-150 ${tipo === "MOTORISTA"
                                    ? "bg-primary text-primary-foreground"
                                    : "bg-muted text-muted-foreground hover:bg-muted/70"
                                    }`}
                            >
                                Motorista (DL)
                            </button>

                            <button
                                onClick={() => setTipo("AUXILIAR_ENTREGA")}
                                className={`px-3 py-1 rounded-md text-sm transition-colors duration-150 ${tipo === "AUXILIAR_ENTREGA"
                                    ? "bg-primary text-primary-foreground"
                                    : "bg-muted text-muted-foreground hover:bg-muted/70"
                                    }`}
                            >
                                Auxiliar de Entrega (DL)
                            </button>

                            <button
                                onClick={() => setTipo("MOTORISTA_CAXIAS")}
                                className={`px-3 py-1 rounded-md text-sm transition-colors duration-150 ${tipo === "MOTORISTA_CAXIAS"
                                    ? "bg-primary text-primary-foreground"
                                    : "bg-muted text-muted-foreground hover:bg-muted/70"
                                    }`}
                            >
                                Motorista (Caxias)
                            </button>

                            <button
                                onClick={() => setTipo("AUXILIAR_ENTREGA_CAXIAS")}
                                className={`px-3 py-1 rounded-md text-sm transition-colors duration-150 ${tipo === "AUXILIAR_ENTREGA_CAXIAS"
                                    ? "bg-primary text-primary-foreground"
                                    : "bg-muted text-muted-foreground hover:bg-muted/70"
                                    }`}
                            >
                                Auxiliar de Entrega (Caxias)
                            </button>

                        </div>

                    </div>
                    <button
                        onClick={handleSave}
                        disabled={saving}
                        className="inline-flex items-center gap-2 h-10 px-5 rounded-md bg-primary text-primary-foreground font-medium text-sm hover:brightness-95 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-150 shadow-xs"
                    >
                        {saving ? <FaSpinner className="animate-spin" /> : <FaSave />}
                        {saving ? "Salvando..." : "Salvar"}
                    </button>
                </div>
            </header>


            {/* Toast */}
            {toast && (
                <div className={`fixed top-4 right-4 z-50 flex items-center gap-2 px-4 py-3 rounded-md shadow-pop text-sm font-medium ${toast.type === "success"
                    ? "bg-success text-success-foreground"
                    : "bg-destructive text-destructive-foreground"
                    }`}>
                    {toast.type === "success" ? <FaCheckCircle /> : <FaExclamationTriangle />}
                    {toast.message}
                </div>
            )}

            <main className="px-4 sm:px-6 py-8 grid grid-cols-2 gap-4">
                {/* Configurações Gerais */}
                <section className="md:col-span-2 bg-card rounded-lg border border-border p-6 shadow-card">
                    <SectionHeader icon={<FaCog />} title="Configurações Gerais" />
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
                        <ToggleField label="Calcula Cubagem" checked={form.calculaCubagem} onChange={set("calculaCubagem")} />
                        <ToggleField label="Calcula Retorno de Vendas" checked={form.calculaRetornoVendas} onChange={set("calculaRetornoVendas")} />
                        <ToggleField label="Calcula Conclusão de Rota" checked={form.calculaConclusaoRota} onChange={set("calculaConclusaoRota")} />
                        {tipo !== "AUXILIAR_ENTREGA" && (
                            <ToggleField label="Calcula Telemetria" checked={form.calculaTelemetria} onChange={set("calculaTelemetria")} />
                        )}
                        <ToggleField label="Desconta Afastamentos" checked={form.descontaAfastamentos} onChange={set("descontaAfastamentos")} />
                        <ToggleField label="Desconta Faltas" checked={form.descontaFaltas} onChange={set("descontaFaltas")} />
                        <ToggleField label="Proporcionalidade Rota" checked={form.aplicarProporcionalidadeRota} onChange={set("aplicarProporcionalidadeRota")} />
                        <ToggleField label="Proporcionalidade Telemetria" checked={form.aplicarProporcionalidadeTelemetria} onChange={set("aplicarProporcionalidadeTelemetria")} />
                        <ToggleField label="Proporcionalidade por Dias Trabalhados" checked={form.aplicarProporcionalidadePorDiasTrabalhados} onChange={set("aplicarProporcionalidadePorDiasTrabalhados")} />
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
                        <NumberInput label="Dia de Fechamento" value={form.diaFechamento} onChange={set("diaFechamento")} step="1" min={1} />
                        <NumberInput label="Máx. Auxiliares por Carga" value={form.maxAuxiliarPorCarga} onChange={set("maxAuxiliarPorCarga")} step="1" min={0} />
                    </div>
                </section>

                {/* Cubagem */}
                <section className="bg-card rounded-lg border border-border p-6 shadow-card">
                    <SectionHeader icon={<FaCube />} title="Cubagem" />
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <NumberInput label="Valor por Cubo (1 Auxiliar)" value={form.valorPorCuboCom1Auxiliar} onChange={set("valorPorCuboCom1Auxiliar")} prefix="R$" />
                        <NumberInput label="Valor Máximo por Cubo (1 Aux)" value={form.valorMaximoPorCuboCom1Auxiliar} onChange={set("valorMaximoPorCuboCom1Auxiliar")} prefix="R$" />
                        <NumberInput label="Valor por Cubo (2 Auxiliares)" value={form.valorPorCuboCom2Auxiliar} onChange={set("valorPorCuboCom2Auxiliar")} prefix="R$" />
                        <NumberInput label="Valor Máximo por Cubo (2 Aux)" value={form.valorMaximoPorCuboCom2Auxiliar} onChange={set("valorMaximoPorCuboCom2Auxiliar")} prefix="R$" />
                    </div>
                </section>

                {/* Rotas e Conclusão */}
                {tipo === "AUXILIAR_ENTREGA_CAXIAS" || tipo === "MOTORISTA_CAXIAS" ?
                    <section className="bg-card rounded-lg border border-border p-6 shadow-card">
                        <SectionHeader icon={<FaRoad />} title="Rotas e Conclusão" />
                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
                            <NumberInput label="Limite Entregas 48h" value={form.notasMinimas48h} onChange={set("notasMinimas48h")} step="1" />
                            <NumberInput label="Prazo dias/ 24h" value={form.prazo24h} onChange={set("prazo24h")} step="1" />
                            <NumberInput label="Prazo dias/ 48h" value={form.prazo48h} onChange={set("prazo48h")} step="1" />
                        </div>
                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                            <NumberInput label="Percentual Conclusão (%)" value={form.percentualConclusao} onChange={set("percentualConclusao")} prefix="%" />
                            <NumberInput label="Valor Conclusão (1 Aux)" value={form.valorConclusaoCom1Auxiliar} onChange={set("valorConclusaoCom1Auxiliar")} prefix="R$" />
                            <NumberInput label="Valor Conclusão (2 Aux)" value={form.valorConclusaoCom2Auxiliar} onChange={set("valorConclusaoCom2Auxiliar")} prefix="R$" />
                        </div>
                    </section>
                    :
                    <section className="bg-card rounded-lg border border-border p-6 shadow-card">
                        <SectionHeader icon={<FaRoad />} title="Rotas e Conclusão" />
                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
                            <NumberInput label="Minutos Rotas 24h" value={form.minutosParaRotas24horas} onChange={set("minutosParaRotas24horas")} step="1" />
                            <NumberInput label="Minutos Rotas 48h" value={form.minutosParaRotas48horas} onChange={set("minutosParaRotas48horas")} step="1" />
                            <NumberInput label="Minutos Rotas 72h" value={form.minutosParaRotas72horas} onChange={set("minutosParaRotas72horas")} step="1" />
                        </div>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                            <NumberInput label="Percentual Conclusão (%)" value={form.percentualConclusao} onChange={set("percentualConclusao")} prefix="%" />
                            <NumberInput label="Percentual Greenmile (%)" value={form.percentualGreenmile} onChange={set("percentualGreenmile")} prefix="%" />
                            <NumberInput label="Valor Conclusão (1 Aux)" value={form.valorConclusaoCom1Auxiliar} onChange={set("valorConclusaoCom1Auxiliar")} prefix="R$" />
                            <NumberInput label="Valor Conclusão (2 Aux)" value={form.valorConclusaoCom2Auxiliar} onChange={set("valorConclusaoCom2Auxiliar")} prefix="R$" />
                        </div>
                    </section>
                }

                {/* Retorno de Vendas */}
                <section className="md:col-span-2 bg-card rounded-lg border border-border p-6 shadow-card">
                    <SectionHeader icon={<FaUndo />} title="Retorno de Vendas" />
                    <div className="mb-4">
                        <NumberInput label="Limite Máximo Percentual Retorno (%)" value={form.limiteMaximoPercentualRetorno} onChange={set("limiteMaximoPercentualRetorno")} prefix="%" />
                    </div>

                    {[1, 2, 3, 4].map((faixa) => (
                        <div key={faixa} className="mb-4 p-4 rounded-md bg-muted border border-border">
                            <h3 className="text-sm font-semibold text-foreground mb-3">
                                <FaPercent className="inline mr-1 text-primary text-xs" /> Faixa {faixa}
                            </h3>
                            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                                <NumberInput
                                    label={`Limite Faixa ${faixa} (%)`}
                                    value={form[`retornoFaixa${faixa}Limite`]}
                                    onChange={set(`retornoFaixa${faixa}Limite`)}
                                    prefix="%"
                                />
                                <NumberInput
                                    label="Valor 1 Auxiliar"
                                    value={form[`retornoFaixa${faixa}Valor1Aux`]}
                                    onChange={set(`retornoFaixa${faixa}Valor1Aux`)}
                                    prefix="R$"
                                />
                                <NumberInput
                                    label="Valor 2 Auxiliares"
                                    value={form[`retornoFaixa${faixa}Valor2Aux`]}
                                    onChange={set(`retornoFaixa${faixa}Valor2Aux`)}
                                    prefix="R$"
                                />
                            </div>
                        </div>
                    ))}

                    <div className="p-4 rounded-md bg-muted/50 border border-border">
                        <h3 className="text-sm font-semibold text-foreground mb-3">
                            <FaPercent className="inline mr-1 text-primary text-xs" /> Faixa 5 (acima do limite)
                        </h3>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                            <NumberInput label="Valor 1 Auxiliar" value={form.retornoFaixa5Valor1Aux} onChange={set("retornoFaixa5Valor1Aux")} prefix="R$" />
                            <NumberInput label="Valor 2 Auxiliares" value={form.retornoFaixa5Valor2Aux} onChange={set("retornoFaixa5Valor2Aux")} prefix="R$" />
                        </div>
                    </div>
                </section>

                {/* Telemetria: regra exclusiva do motorista (o backend ignora para o auxiliar) */}
                <section className="bg-card rounded-lg border border-border p-6 shadow-card">
                    <SectionHeader icon={<FaTachometerAlt />} title="Telemetria" />
                    {tipo === "AUXILIAR_ENTREGA" ? (
                        <p className="text-sm text-muted-foreground">
                            A telemetria (segurança viária) não se aplica ao auxiliar de entrega: somente o motorista é premiado por ela.
                        </p>
                    ) : (
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                            <NumberInput label="Meta Telemetria" value={form.metaTelemetria} onChange={set("metaTelemetria")} />
                            <NumberInput label="Valor Telemetria (1 Aux)" value={form.valorTelemetriaCom1Auxiliar} onChange={set("valorTelemetriaCom1Auxiliar")} prefix="R$" />
                            <NumberInput label="Valor Telemetria (2 Aux)" value={form.valorTelemetriaCom2Auxiliar} onChange={set("valorTelemetriaCom2Auxiliar")} prefix="R$" />
                            <NumberInput label="Valor Telemetria Sem Proporção" value={form.valorTelemetriaSemProporcao} onChange={set("valorTelemetriaSemProporcao")} prefix="R$" />
                        </div>
                    )}
                </section>

                {/* Cargos */}
                <section className="bg-card rounded-lg border border-border p-6 shadow-card">
                    <SectionHeader icon={<FaUsers />} title="Cargos" />
                    <div className="grid md:grid-cols-1 gap-4">

                        <ToggleField label="Mostrar Somente Funcionário Ativo?" checked={form.exibeSomenteFuncionariosAtivos} onChange={set("exibeSomenteFuncionariosAtivos")} />

                        <CargoSelector
                            titulo="Cargos de Motoristas"
                            cargosDisponiveis={cargos}
                            cargosSelecionados={form.cargosDeMotoristas}
                            setForm={setForm}
                            field="cargosDeMotoristas"
                            cor="blue"
                        />

                        <CargoSelector
                            titulo="Cargos de Auxiliares"
                            cargosDisponiveis={cargos}
                            cargosSelecionados={form.cargosDeAuxiliares}
                            setForm={setForm}
                            field="cargosDeAuxiliares"
                            cor="green"
                        />



                    </div>
                </section>

                {/* Versão */}
                <section className="bg-card rounded-lg border border-border p-6 shadow-card">
                    <SectionHeader icon={<FaCalendarAlt />} title="Versão" />
                    <div className="max-w-xs">
                        <FieldLabel>Versão</FieldLabel>
                        <input
                            type="text"
                            value={form.versao}
                            onChange={(e) => set("versao")(e.target.value)}
                            className="w-full h-10 rounded-md border border-input bg-card px-3 text-sm text-foreground focus:outline-none focus:ring-2 focus:ring-ring transition-shadow duration-150"
                        />
                    </div>
                </section>

            </main>
            <div className="flex justify-end pb-8">
                <button
                    onClick={handleSave}
                    disabled={saving}
                    className="inline-flex items-center gap-2 h-10 px-6 rounded-md bg-primary text-primary-foreground font-medium text-sm hover:brightness-95 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-150 shadow-xs"
                >
                    {saving ? <FaSpinner className="animate-spin" /> : <FaSave />}
                    {saving ? "Salvando..." : "Salvar Parâmetros"}
                </button>
            </div>
        </div>
    );
}

const CARGO_COLOR_VARIANTS = {
    blue: {
        button: "bg-blue-600 hover:bg-blue-700",
        chip: "bg-blue-100 text-blue-700",
        remove: "text-blue-700",
    },
    green: {
        button: "bg-success hover:brightness-95",
        chip: "bg-success/10 text-success",
        remove: "text-success",
    },
};

function CargoSelector({
    titulo,
    cargosDisponiveis,
    cargosSelecionados,
    setForm,
    field,
    cor = "blue"
}) {

    const cores = CARGO_COLOR_VARIANTS[cor] || CARGO_COLOR_VARIANTS.blue;

    const [cargoSelecionado, setCargoSelecionado] = useState("");

    function adicionar() {
        if (!cargoSelecionado) return;

        if (!cargosSelecionados.includes(cargoSelecionado)) {
            setForm(prev => ({
                ...prev,
                [field]: [...prev[field], cargoSelecionado]
            }));
        }

        setCargoSelecionado("");
    }

    function remover(index) {
        setForm(prev => ({
            ...prev,
            [field]: prev[field].filter((_, i) => i !== index)
        }));
    }

    return (
        <div className="bg-muted shadow-card rounded-xl p-6 space-y-4">

            <h2 className="font-medium text-foreground">{titulo}</h2>

            <div className="flex gap-2">
                <select
                    value={cargoSelecionado}
                    onChange={e => setCargoSelecionado(e.target.value)}
                    className="border border-input rounded-lg px-3 py-2 flex-1 bg-card text-foreground"
                >
                    <option value="">Selecione um cargo...</option>

                    {cargosDisponiveis.map(c => (
                        <option key={c} value={c}>{c}</option>
                    ))}
                </select>

                <button
                    onClick={adicionar}
                    className={`text-white px-4 rounded-lg transition-colors duration-150 ${cores.button}`}
                >
                    +
                </button>
            </div>

            <div className="flex flex-wrap gap-2">

                {cargosSelecionados.map((c, i) => (
                    <span
                        key={i}
                        className={`px-3 py-1 rounded-full flex items-center gap-2 ${cores.chip}`}
                    >
                        {c}

                        <button
                            onClick={() => remover(i)}
                            className={`font-bold ${cores.remove}`}
                        >
                            ×
                        </button>
                    </span>
                ))}

            </div>

        </div>
    );
}


function SectionHeader({ icon, title }) {
    return (
        <div className="flex items-center gap-2 mb-4 pb-2 border-b-2 border-primary/20">
            <span className="text-primary text-lg">{icon}</span>
            <h2 className="text-lg font-bold font-display text-foreground">{title}</h2>
        </div>
    );
}

function FieldLabel({ children }) {
    return <label className="block text-sm font-medium text-muted-foreground mb-1">{children}</label>;
}

function ToggleField({ label, checked, onChange }) {
    return (
        <label className="flex items-center gap-3 cursor-pointer select-none py-2 px-3 rounded-md hover:bg-muted transition-colors duration-150">
            <div
                className={`relative w-11 h-6 rounded-full transition-colors duration-150 ${checked ? "bg-primary" : "bg-muted-foreground/30"}`}
                onClick={(e) => { e.preventDefault(); onChange(!checked); }}
            >
                <div
                    className={`absolute top-0.5 left-0.5 w-5 h-5 rounded-full bg-card shadow-xs transition-transform duration-150 ${checked ? "translate-x-5" : "translate-x-0"}`}
                />
            </div>
            <span className="text-sm text-foreground">{label}</span>
        </label>
    );
}

function NumberInput({ label, value, onChange, prefix, step = "0.001", min }) {
    return (
        <div>
            <FieldLabel>{label}</FieldLabel>
            <div className="relative">
                {prefix && (
                    <span className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground text-sm">{prefix}</span>
                )}
                <input
                    type="number"
                    step={step}
                    min={min}
                    value={value}
                    onChange={(e) => onChange(parseFloat(e.target.value) || 0)}
                    className={`w-full h-10 rounded-md border border-input bg-card text-sm text-foreground focus:outline-none focus:ring-2 focus:ring-ring transition-shadow duration-150 ${prefix ? "px-8" : "px-3"}`}
                />
            </div>
        </div>
    );
}